export const DEFAULT_INPUT_ERROR_MESSAGES = {
  required: 'This field is required',
  default: 'This field is invalid.',
};
